import { useEffect, useState } from "react";

export interface TocItem {
  id: string;
  label: string;
}

interface ArticleTocProps {
  items: TocItem[];
}

export default function ArticleToc({ items }: ArticleTocProps) {
  const [activeId, setActiveId] = useState(items[0]?.id ?? "");

  useEffect(() => {
    const onScroll = () => {
      let current = items[0]?.id ?? "";
      items.forEach((item) => {
        const el = document.getElementById(item.id);
        if (el && el.getBoundingClientRect().top <= 140) {
          current = item.id;
        }
      });
      setActiveId(current);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, [items]);

  return (
    <nav
      aria-label="本页目录"
      className="rounded-lg border border-background-200 bg-background-50 p-5"
    >
      <h2 className="mb-4 flex items-center gap-2 font-heading text-sm font-bold text-foreground-950">
        <i className="ri-list-check-2 text-primary-500" />
        本页目录
      </h2>
      <ul className="space-y-1">
        {items.map((item) => (
          <li key={item.id}>
            <a
              href={`#${item.id}`}
              className={`block border-l-2 py-1.5 pl-3 text-sm transition-colors ${
                activeId === item.id
                  ? "border-primary-500 font-medium text-primary-600"
                  : "border-background-200 text-foreground-600 hover:border-primary-300 hover:text-primary-600"
              }`}
            >
              {item.label}
            </a>
          </li>
        ))}
      </ul>
    </nav>
  );
}